// extracted by mini-css-extract-plugin
module.exports = {"roundImage":"About-module--roundImage--2jG0l"};